/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectivity_History_Reboots_HelpInputs */



/**
* | output |
* | --- |
* | "Inferred from messages received earlier than expected" |
*
* @param {Connectivity_History_Reboots_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_reboots_help = /** @type {((inputs?: Connectivity_History_Reboots_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_Reboots_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Inferred from messages received earlier than expected")
	return /** @type {LocalizedString} */ ("Déduits des messages reçus plus tôt que prévu")
});